export const sparePartRequestFormData = () => ({
  inputData: {
    // id: null,
    job_card_id: null,
    spare_id: null,
    quantity: null,

    status: null,
    issue_qty: null,
    is_active: true,
  },
});

export const createPageData = () => {
  const payload = {
    modelName: "spare_part_requests",
    schema: "public",

    include: [
      {
        model: "job_cards",
        as: "job_card",
      },
      {
        model: "material_masters",
        as: "spare",
      },
      {
        model: "user_masters",
        as: "requested_by_user",
      },
      {
        model: "spare_part_issues",
        as: "issues",
      },
    ],
  };

  const navigatePage = { back: "/spare-part-requests-list" };

  const headerName = "Spare Part Request";

  const validationType = "SparePartRequestsCreate";
  const createEndpoint = "/updaterelationaldata";
  const updateEndpoint = "/updaterelationaldata  ";

  const getEndpoint = "/getRecords";

  return {
    payload,
    navigatePage,
    headerName,
    validationType,
    createEndpoint,
    updateEndpoint,
    getEndpoint,
  };
};
